<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <!-- <admin-sidebar-menu v-if="admin" /> -->
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Add Student</h3>
          </div>
          <div class="heading-seperator"></div>
          <div class="margin-bottom-10"></div>
          <div class="content-main-wrapper signin-form add_account_form center">
            <form @submit.prevent="onSubmit">
          		<div class="row margin-bottom-15">
          		  <div class="col-12 col-sm-12">
                <label
          					for="first_name"
          					class="col-12">First name : <span class="required">*</span></label>
          			<input
          					type="first_name"
          					name="first_name"
          					id="first_name"
          					class="col-12 col-sm-12 input-height-35"
          					ref="first_name"
          					v-validate="'required'"
          					v-model="first_name"
                    data-vv-as="First name"
                    maxlength="180">
          			<div v-show="verrors.has('first_name')" class="validate-warning-msg">{{ verrors.first('first_name') }}</div>
          		  </div>
          		</div>
          		<div class="row margin-bottom-15">
          		  <div class="col-12 col-sm-12">
                <label
          					for="last name"
          					class="col-12">Last name : <span class="required">*</span></label>
          			<input
          					type="last_name"
          					name="last_name"
          					id="last_name"
          					class="col-12 col-sm-12 input-height-35"
          					ref="last_name"
          					v-validate="'required'"
          					v-model="last_name"
                    data-vv-as="Last name"
                    maxlength="180">
          			<div v-show="verrors.has('last_name')" class="validate-warning-msg">{{ verrors.first('last_name') }}</div>
          		  </div>
          		</div>
          		<div class="row margin-bottom-15">
          		  <div class="col-12 col-sm-12">
                <label
          					for="email"
          					class="col-12">Email address : <span class="required">*</span></label>
          			<input
          					type="email_addr"
          					name="email"
          					id="email_addr"
          					class="col-12 col-sm-12 input-height-35"
          					ref="email_addr"
          					v-validate="'required|email'"
          					v-model="email_addr"
                    data-vv-as="Email address"
                    maxlength="180">
          			<div v-show="verrors.has('email')" class="validate-warning-msg">{{ verrors.first('email') }}</div>
          		  </div>
          		</div>
          		<div class="row margin-bottom-15">
          		  <div class="col-12 col-sm-12">
          			<label
          					for="group"
          					class="col-12">Group : <span class="required">*</span></label>
                    <b-form-select
                      v-model="groups_selected"
                      :options="groups"
                      @change="onChange()"
                      class="mb-3"
                      name="groups_selected"
                      v-validate="'required'"
                      data-vv-as="Groups"  v-if="groups" />
                    <div v-show="verrors.has('groups_selected')" class="validate-warning-msg">{{ verrors.first('groups_selected') }}</div>
          		  </div>
          		</div>

              <div v-if="group_tasklists.length > 0" class="row margin-bottom-15">
                <div class="col-12 col-sm-12">
                  <label
                      for="roles"
                      class="col-12">Tasklists to be assigned :</label>
                  <b-card no-body>
                    <b-tabs card>
                      <b-tab v-if="group_tasklist.tasklists.length > 0" :title="group_tasklist.name" v-for="(group_tasklist, index) in group_tasklists" v-bind:key="index">
                        <div class="margin-bottom-10"></div>
                        <b-card-text>
                          <div class="col-12 col-sm-12 override-padding tasklist-assign-wrapper" v-for="(option, key, index) in group_tasklist.tasklists">
                            <div class="chkboxwrapper">
                              <input :value="option.id" :id="option.id" type="checkbox" name="tasklist_assigned" v-model="tasklist_assigned" class="float-left" style="margin-top: 2px;">
                              <label :for="option.name" class="float-left" style="margin-left: 4px;">{{ option.name }}</label>
                              <div style="clear: both;"></div>
                            </div>
                          </div>
                        </b-card-text>
                      </b-tab>
                    </b-tabs>
                  </b-card>
                </div>
              </div>

              <div class="submit margin-bottom-15">
                <button type="submit" class="btn btn-info btn-md">Add this Student</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import store from '../../store/store.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
      first_name: '',
      last_name: '',
      email_addr: '',
      groups_selected: '',
      password: '',
      pw_confirm: '',
	    selected: '',
      groups: [{value: '', text: 'Please Select'}],
      group_tasklists: [],
      tasklist_assigned: [],
      accountId: '',
      admin: false,
    };
  },
  methods: {
    onChange() {
      this.group_tasklists = [];
      if(this.groups_selected > 0) {
        axios.get('/tasklists-group', {
          params: {
            group_id: this.groups_selected,
            account_id: this.$route.params.account_id,
          }
        })
        .then(response => {
            this.tasklist_assigned = [];
            this.group_tasklists = response.data;
            for(var i=0; i < this.group_tasklists[0].tasklists.length; i++) {
              this.tasklist_assigned.push(this.group_tasklists[0].tasklists[i].id);
            }
         })
        .catch(error => {

        });

      }
      return false;
    },
    onSubmit () {
        this.$validator.validateAll().then((result) => {
          if(!result) {
            return;
          }
          this.createStudent();
        })
        .catch(() => {

        });
    },

    createStudent() {

        axios('/users',
          {
            method: 'POST',
            data: {
                   "username": this.email_addr,
                   "email": this.email_addr,
                   "roles": ["ROLE_STUDENT"],
                   "first_name": this.first_name,
                   "last_name": this.last_name,
                   "group": this.groups_selected,
                   "enabled": true,
                   "tasklists_assigned": this.tasklist_assigned,
                   "signin_count": 0,
                   "account_id": this.accountId,
                   }
          },
        )
        .then(response => {
            this.flash({ message: response.data.successMsg, variant: 'success' });
            if(this.accountId) {
              this.navigate('/list-account-users/' + this.accountId);
            }
            else {
              this.navigate('/school-admin-dashboard');
            }
         })
        .catch(error => {
            const fieldErrors =  [{}];
            var errMsgObj = error.response.data.message;
            Object.keys(errMsgObj).map(key => {
               var newFieldErr = {field:key, msg:errMsgObj[key]};
               fieldErrors.push(newFieldErr);
            });
            this.$validator.errors.add(fieldErrors);
         });
    },
    navigate(path) {
      router.push(path);
    },
  },
  components: {
    UserMenu,
    GoBack,
    AdminSidebarMenu
  },
  beforeCreate() {
      axios('/accountgroups',
        {
          method: 'GET',
          params: {
            account_id: this.$route.params.account_id,
          }
        },
      )
      .then(response => {
          for(var i=0; i < response.data.length; i++) {
            var group = {value: response.data[i].id, text: response.data[i].groupName};
            this.groups.push(group);
          }
       })
      .catch(error => {
         console.log(error);
      });

  },
  created: function() {
    this.accountId = this.$route.params.account_id;
    var roles = this.$store.state.roles;
    if((roles.indexOf('ROLE_ADMIN') > -1) || (this.$store.state.switch_admin_username)) {
      this.admin = true;
    }
  }

}
</script>

<style scoped>

.custom-select {
  height: 40px;
}
.tasklist-assign-wrapper label {
    font-weight: normal;
}
.card {
  background: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/primaryadmin/add_student.vue